import { useState } from "react";
import {
  Box,
  Grid,
  Text,
  Avatar,
  Button,
  DropDown,
} from "@flexisaf/flexibull2";
import styled from "styled-components";
import parse from "html-react-parser";
import Theme from "../../../theme";
import SectionEditor from "../../../components/Section/modals/sectionEditor";
import useSectionsGet from "../../../hooks/sections/useSectionsGet";
import { EmptyState } from "@flexisaf/flexibull2/build/emptystates";
import useSectionCreate from "../../../hooks/sections/useSectionEditor";
import SectionLoader from "../../../components/custom/sectionLoader";
import { FlexiPagination } from "@flexisaf/flexibull2/build/table";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";

const Section = ({ paperId }) => {
  const [modal, setModal] = useState({
    show: false,
    data: null,
  });

  const {
    loadingSection,
    sections,
    setLimit,
    limit,
    totalElements,
    page,
    setPage,
    pageOptions,
    searchText,
    refetch,
  } = useSectionsGet(paperId);
  const [deleteSectionModal, setDeleteSectionModal] = useState({
    openModal: false,
    data: null,
  });

  const { isDeleting, deleteSection } = useSectionCreate();
  const handleSectionDelete = (id) => {
    deleteSection({
      id,
      callback: () => {
        refetch();
      },
    });
  };

  if (loadingSection && searchText === "")
    return <SectionLoader color={Theme.PrimaryColor} height="60vh" />;

  if (isDeleting)
    return <SectionLoader color={Theme.PrimaryColor} height="60vh" />;

  return (
    <Box>
      <Box>
        <Box align="right">
          <Button
            onClick={() =>
              setModal({
                show: true,
                data: null,
              })
            }
          >
            <Text>Add section</Text>
          </Button>
        </Box>
      </Box>

      <Box margin="30px 0">
        {sections?.items?.length > 0 ? (
          <>
            <Grid default=" repeat( auto-fit, minmax(350px, 1fr) )">
              {sections?.items?.map((section, index) => {
                return (
                  <SectionCell onClick={() => {}} key={index}>
                    <Box>
                      <CardTop>
                        <Text color={Theme.PrimaryGrey}>{section.title}</Text>
                        <DropDown
                          label={
                            <Text
                              bold
                              size="14px"
                              style={{ cursor: "pointer" }}
                            >
                              ...
                            </Text>
                          }
                          menuAlign="bottom right"
                          trigger="click"
                          menuList={[
                            {
                              onClick: () =>
                                setModal({
                                  show: true,
                                  data: section,
                                }),
                              label: "Edit Section",
                              iconLeft: "saf-receipt-edit",
                            },
                            {
                              onClick: () => {
                                setDeleteSectionModal({
                                  data: section?.id,
                                  openModal: true,
                                });
                              },
                              label: "Delete Section",
                              color: Theme.PrimaryRed,
                              iconLeft: "saf-trash",
                              process: isDeleting,
                            },
                          ]}
                        />
                      </CardTop>
                    </Box>
                    <Box style={{ flexGrow: 2 }}>
                      <Box
                        margin="20px 0"
                        style={{
                          maxHeight: "12rem",
                          minHeight: "8rem",
                          overflowY: "scroll",
                          height: "100%",
                          scrollbarWidth: "none",
                        }}
                      >
                        {parse(section?.content || "")}
                      </Box>
                    </Box>
                    <CardBottom>
                      <Box>
                        <Box display="flex" style={{ alignItems: "center" }}>
                          <Avatar
                            name={`SAFlearn Admin`}
                            margin="0 10px 0 0"
                            size="30px"
                            round
                          />
                          <Text>SAFlearn admin</Text>
                        </Box>
                      </Box>
                    </CardBottom>
                  </SectionCell>
                );
              })}
            </Grid>
            <FlexiPagination
              pageCounts={pageOptions}
              itemsDisplayed
              total={totalElements}
              pageSize={limit}
              onChange={(page) => {
                setPage(page);
              }}
              changePageSize={({ value }) => {
                setPage(1);
                setLimit(value);
              }}
              current={page}
            />
          </>
        ) : (
          <EmptyState
            type="documents"
            title="There are currently no section."
            action={
              <Box align="center">
                <Button
                  width={200}
                  onClick={() =>
                    setModal({
                      show: true,
                      data: null,
                    })
                  }
                  spaceRight
                >
                  Add Section
                </Button>
              </Box>
            }
          />
        )}
      </Box>

      <SectionEditor
        open={modal.show}
        closeModal={() => {
          setModal({
            show: false,
            data: null,
          });
        }}
        data={modal.data}
        paperId={paperId}
        refetch={refetch}
      />

      <DeleteModal
        isOpen={deleteSectionModal.openModal}
        onClose={() => setDeleteSectionModal({ openModal: false, data: null })}
        title="Delete Section"
        description="This action will delete the section from the system"
        isLoading={isDeleting}
        onDelete={() => {
          handleSectionDelete(deleteSectionModal?.data);
          setDeleteSectionModal({ openModal: false, data: null });
        }}
      />
    </Box>
  );
};

export default Section;

const SectionCell = styled(Box)`
  background-color: #fff;
  border-radius: ${Theme.PrimaryRadius};
  box-sizing: border-box;
  padding: 22px;
  display: flex;
  flex-direction: column;
  /* cursor: pointer; */
  max-width: 30vw;
`;

const CardTop = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
const CardBottom = styled.div`
  max-height: 100px;
`;
